import { useState, type FormEvent } from "react";
import Reveal from "@/components/base/Reveal";

export default function SubmitSection() {
  const [notice, setNotice] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setNotice("本页为内容演示站点，线索提交功能尚未接入，感谢你的浏览。");
  };

  return (
    <section id="submit" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="grid grid-cols-1 gap-8 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 md:grid-cols-2 md:p-10">
            <div>
              <span className="text-xs font-medium tracking-[0.24em] text-primary-600">
                TIP LINE
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                有线索？交给编辑整理
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-secondary-600">
                如果你手里有更完整的聊天记录、录音证据或内部截图，可以按下面的入口提交线索。
                我们会先核对来源与时间戳，再决定是否并入完整时间线。
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  "提交前请确认材料来源可靠、时间信息完整",
                  "涉及他人隐私的内容不予收录与展示",
                  "我们反对网络暴力，不发布攻击性内容",
                ].map((tip) => (
                  <li
                    key={tip}
                    className="flex items-start gap-2 text-sm text-foreground-800"
                  >
                    <i className="ri-checkbox-circle-line mt-0.5 text-base text-accent-600" />
                    {tip}
                  </li>
                ))}
              </ul>
            </div>

            <form
              onSubmit={handleSubmit}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex flex-col gap-4">
                <label className="flex flex-col gap-1.5">
                  <span className="text-xs font-medium text-foreground-800">
                    称呼
                  </span>
                  <input
                    type="text"
                    name="nickname"
                    placeholder="怎么称呼你（可留空）"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 placeholder:text-secondary-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  />
                </label>
                <label className="flex flex-col gap-1.5">
                  <span className="text-xs font-medium text-foreground-800">
                    联系方式
                  </span>
                  <input
                    type="text"
                    name="contact"
                    placeholder="邮箱或站内私信，方便编辑回复"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 placeholder:text-secondary-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  />
                </label>
                <label className="flex flex-col gap-1.5">
                  <span className="text-xs font-medium text-foreground-800">
                    线索简述
                  </span>
                  <textarea
                    name="detail"
                    rows={4}
                    maxLength={500}
                    placeholder="简要描述你掌握的材料内容与时间节点（不超过 500 字）"
                    className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 placeholder:text-secondary-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  />
                </label>
              </div>

              <button
                type="submit"
                className="mt-5 inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line text-base" />
                提交线索
              </button>

              {notice && (
                <p className="mt-3 flex items-start gap-2 rounded-md bg-accent-50 px-3 py-2.5 text-xs leading-relaxed text-accent-900">
                  <i className="ri-information-line mt-0.5 text-sm" />
                  {notice}
                </p>
              )}
              <p className="mt-3 text-[11px] leading-relaxed text-secondary-500">
                本站为内容演示站点，表单不接入任何接口，不会真实提交或存储你的信息。
              </p>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
}